document.addEventListener('DOMContentLoaded', function() {
    // Function to handle adding/removing from wishlist
    function toggleWishlist(variantId, linkElement) {
        let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
        const index = wishlist.indexOf(variantId);

        if (index === -1) {
            // Add the variant to the wishlist
            wishlist.push(variantId);
            localStorage.setItem('wishlist', JSON.stringify(wishlist));
            // Add the 'wish' class to the link element
            linkElement.classList.add('wish');
        } else {
            // Remove the variant from the wishlist
            wishlist.splice(index, 1);
            localStorage.setItem('wishlist', JSON.stringify(wishlist));
            // Remove the 'wish' class from the link element
            linkElement.classList.remove('wish');
        }
    }

    // Function to update the wishlist link's appearance on page load
    function updateWishlistLinkAppearance() {
        document.querySelectorAll('.wishlist-link').forEach(link => {
            const variantId = link.getAttribute('data-variant-id');
            let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
            
            if (wishlist.includes(variantId)) {
                link.classList.add('wish');
            } else {
                link.classList.remove('wish');
            }
        });
    }

    // Attach event listener to all wishlist links
    document.querySelectorAll('.wishlist-link').forEach(link => {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            const variantId = link.getAttribute('data-variant-id');
            toggleWishlist(variantId, link);
        });
    });

    // Initial update of the wishlist link appearance
    updateWishlistLinkAppearance();

    checkContentHeight();
});

/*
function checkContentHeight() {
    // Select the specific .easytabs-content-holder element
    var contentHolder = document.querySelector(
      '.easytabs-container .easytabs-accordion .easytabs-contents .easytabs-active[data-et-handle="tabs-description"] .easytabs-content-holder'
    );

    if (contentHolder) {
      // Temporarily remove max-height to measure full content height
      var prevMaxHeight = contentHolder.style.maxHeight;
      contentHolder.style.maxHeight = 'none';

      // Force reflow to ensure accurate measurement
      contentHolder.offsetHeight;

      // Get the actual height of the content
      var contentHeight = contentHolder.scrollHeight;

      // Restore the previous max-height
      contentHolder.style.maxHeight = prevMaxHeight;

      // Check if the height exceeds 80 pixels
      if (contentHeight > 80) {
        // Add the 'see-more' class to the .easytabs-content-holder element
        contentHolder.classList.add('see-more');

        // Add the "See More" functionality
        addSeeMoreFunctionality(contentHolder);
      } else {
        contentHolder.classList.remove('see-more');
      }
    } else {
      console.log('Content holder element not found.');
    }
}

function addSeeMoreFunctionality(contentHolder) {
  var tabContainer = document.querySelector(
    '.easytabs-container .easytabs-accordion .easytabs-contents .easytabs-active[data-et-handle="tabs-description"]'
  );

  // Check if the link already exists
  var existingLink = tabContainer.querySelector('.see-more-link');
  if (existingLink) {
    return;
  }

  // Create the "See More" link
  var seeMoreLink = document.createElement('a');
  seeMoreLink.href = 'javascript:void(0);'; // Prevent navigation
  seeMoreLink.className = 'see-more-link';
  seeMoreLink.textContent = 'See More';

  // Append the link to the tab container
  tabContainer.appendChild(seeMoreLink);

  // Set initial max-height to 80px for contentHolder
  //contentHolder.style.maxHeight = '100px';

  // Add click event listener to the link
  seeMoreLink.addEventListener('click', function (event) {
    event.preventDefault(); // Prevent default browser behavior (no new window)

    // Call function to toggle content expansion
    toggleContentExpansion(contentHolder, seeMoreLink);
  });
}
*/

function toggleContentExpansion(contentHolder, link) {
  var isExpanded = contentHolder.classList.contains('expanded');

  if (isExpanded) {
    // Collapse the content with transition
    //contentHolder.style.maxHeight = contentHolder.scrollHeight + 'px';

    // Force a reflow to ensure the transition is triggered
    //contentHolder.offsetHeight; // Trigger reflow

    // Now set it to the collapsed state (max-height: 80px)
    //contentHolder.style.maxHeight = '100px';
    contentHolder.classList.remove('expanded');
    link.textContent = 'See More';
  } else {
    // Expand the content
    //contentHolder.style.maxHeight = contentHolder.scrollHeight + 'px';
    contentHolder.classList.add('expanded');
    link.textContent = 'See Less';
  }
}


/*
// Function to initialize the add-to-cart functionality
function initRelatedProductsAddToCart() {
  // Function to handle the AJAX Add to Cart
  function ajaxAddToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }]
      })
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(err => { throw err; });
      }
      return response.json();
    })
    .then(data => {
      // Dispatch the 'on:cart:add' event
      document.dispatchEvent(new CustomEvent('on:cart:add', {
        detail: {
          cart: data, // The cart object returned from Shopify
          variantId: variantId
        },
        bubbles: true
      }));

      // Dispatch the 'dispatch:cart-drawer:refresh' event to refresh the cart drawer
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
        bubbles: true
      }));

      // Open the cart drawer
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
        bubbles: true
      }));

      // Optionally, update the cart count
      if (data && data.item_count !== undefined) {
        updateCartCount(data.item_count);
      }
    })
    .catch((error) => {
      console.error('Error adding item to cart:', error);

      // Dispatch the 'on:cart:error' event
      document.dispatchEvent(new CustomEvent('on:cart:error', {
        detail: {
          error: error.message || 'An error occurred while adding the item to the cart.'
        },
        bubbles: true
      }));
    });
  }

  // Function to update cart count
  function updateCartCount(itemCount) {
    const cartCountElements = document.querySelectorAll('.cart-count');
    cartCountElements.forEach(function(element) {
      element.textContent = itemCount;
    });
  }

  // Function to dispatch cart error events
  function dispatchCartError(message) {
    document.dispatchEvent(new CustomEvent('on:cart:error', {
      detail: {
        error: message
      },
      bubbles: true
    }));
  }

  // Attach event listeners to the related products' Add to Cart buttons
  const relatedProductButtons = document.querySelectorAll('.ga-product_addtocart');

  if (relatedProductButtons.length > 0) {
    relatedProductButtons.forEach(function(button) {
      // Avoid adding multiple event listeners
      if (!button.classList.contains('event-attached')) {
        button.classList.add('event-attached');

        button.addEventListener('click', function(event) {
          event.preventDefault();

          // Find the closest parent 'ga-product' element
          const parentProductElement = button.closest('.ga-product');
          if (parentProductElement) {
            // Find the variant select element within the product
            const variantSelect = parentProductElement.querySelector('.ga-product_variant_select');
            if (variantSelect) {
              // Get the selected variant ID
              const variantId = variantSelect.value;
              if (variantId) {
                ajaxAddToCart(variantId);
              } else {
                console.error('Variant ID not found for the product.');
                dispatchCartError('Variant ID not found for the product.');
              }
            } else {
              console.error('Variant select element not found for the product.');
              dispatchCartError('Variant select element not found for the product.');
            }
          } else {
            console.error('Parent product element not found.');
            dispatchCartError('Parent product element not found.');
          }
        });
      }
    });
  }
}

// Function to initialize the add-to-cart functionality
function moveRelatedProductDivs() {
  // Select all list items with the class 'ga-product'
  const gaProductListItems = document.querySelectorAll('.ga-product');

  gaProductListItems.forEach(function (listItem) {
    // Find the .ga-product_addtocart_wp element within the current list item
    const addToCartElement = listItem.querySelector('.ga-product_addtocart_wp');
    // Find the .ga-related-vertical-content element within the current list item
    const relatedContentElement = listItem.querySelector('.ga-related-vertical-content');

    // Check if both elements exist
    if (addToCartElement && relatedContentElement) {
      // Move the .ga-product_addtocart_wp element into the .ga-related-vertical-content element
      relatedContentElement.appendChild(addToCartElement);
    }
  });  
}

// Function to observe the DOM for the related products section
function observeRelatedProductsSection() {
  const targetNode = document.body; // Observe the entire body or a specific container
  const config = { childList: true, subtree: true };

  const observer = new MutationObserver((mutationsList, observer) => {
    // Check if the elements are present
    if (document.querySelector('.ga-product_addtocart')) {
      // Elements are found, initialize the add-to-cart functionality
      initRelatedProductsAddToCart();
      // You can choose to disconnect the observer if you don't need to watch for further changes
      observer.disconnect();
    } 

    setTimeout(moveRelatedProductDivs, 500);
  });

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);
}
*/

// Start observing when the script loads
// observeRelatedProductsSection();
